import { useFieldArray } from "@bps/fluent-ui";

import { JobsConfigurationCommand, JobsConfigurationJob } from "./dtos";

export const useJobsFormOperations = () => {
  const {
    value: jobs,
    actions: { remove, push, update }
  } = useFieldArray<JobsConfigurationJob>("jobs");

  const getJobIndexById = (id: string) => {
    return jobs.findIndex(x => x.id === id);
  };

  const addJob = (job: JobsConfigurationJob) => {
    const newJob = {
      ...job,
      commands: []
    };

    push(newJob);
  };

  const updateJob = (job: JobsConfigurationJob) => {
    const jobIndex = getJobIndexById(job.id);

    if (jobIndex < 0) return;

    update(jobIndex, job);
  };

  const deleteJob = (job: JobsConfigurationJob) => {
    const jobIndex = getJobIndexById(job.id);

    if (jobIndex < 0) return;

    remove(jobIndex);
  };

  const addCommand = (
    command: JobsConfigurationCommand,
    job: JobsConfigurationJob
  ) => {
    const jobIndex = jobs.findIndex(x => x.id === job.id);

    if (jobIndex < 0) return;

    const { commands, ...rest } = job;
    const updatedJob = {
      ...rest,
      commands: commands.concat([command])
    };

    update(jobIndex, updatedJob);
  };

  const updateCommand = (
    command: JobsConfigurationCommand,
    job: JobsConfigurationJob
  ) => {
    const jobIndex = getJobIndexById(job.id);

    if (jobIndex < 0) return;

    const { commands, ...rest } = job;
    const updatedJob = {
      ...rest,
      commands: commands.map(x => {
        if (x.id !== command.id) return x;
        return command;
      })
    };

    update(jobIndex, updatedJob);
  };

  const deleteCommand = (
    command: JobsConfigurationCommand,
    job: JobsConfigurationJob
  ) => {
    const jobIndex = getJobIndexById(job.id);

    if (jobIndex < 0) return;

    const { commands, ...rest } = job;
    const updatedJob = {
      ...rest,
      commands: commands.filter(x => x.id !== command.id)
    };

    update(jobIndex, updatedJob);
  };

  return {
    jobs,
    addJob,
    updateJob,
    deleteJob,
    addCommand,
    updateCommand,
    deleteCommand
  };
};
